import { render } from "./ThemeArtworks.vue?vue&type=template&id=7e9a9882&scoped=true"
import script from "./ThemeArtworks.vue?vue&type=script&lang=js"
export * from "./ThemeArtworks.vue?vue&type=script&lang=js"

import "./ThemeArtworks.vue?vue&type=style&index=0&id=7e9a9882&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9a9882"]])

export default __exports__